export enum ConferenceTableColumns {
  Images = "images",
  NameLocal = "nameLocal",
  NameLatin = "nameLatin",
  AbbreviationLocal = "abbreviationLocal",
  AbbreviationLatin = "abbreviationLatin",
  ConferenceId = "conferenceId",
  ExternalId = "externalId",
}
